module.exports = __webpack_public_path__ + "static/the-farm-project-lettuce-grow-logo.8f401daf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/the-farm-project-lettuce-grow-logo.svg
// module id = 408
// module chunks = 267508049536846